// extracted by mini-css-extract-plugin
module.exports = {"headerWrapper":"InactiveClientMasterView_headerWrapper__27hmm","headerLeft":"InactiveClientMasterView_headerLeft__3MK5d","backButton":"InactiveClientMasterView_backButton__2Rz7G"};